module.exports = __webpack_public_path__ + "media/programs/ai-program-43c211ba.png";